import { combineReducers } from 'redux';

import authReducer from './auth/auth.reducer';
import cityControlReducer from './city-control/city-control.reducer';
import cityReducer from './city/city.reducer';
import countryReducer from './country/country.reducer';
import grappiReducer from './grappi/grappi.reducer';
import liveOpsReducer from './live-ops/live-ops.reducer';
import mapReducer from './map/map.reducer';
import microzonesReducer from './microzones/microzones.reducer';
import operationReducer from './operation/operation.reducer';
import redbuttonReducer from './redbutton/redbutton.reducer';
import saturationReducer from './saturation/saturation.reducer';
import storeReducer from './store/store.reducer';
import toolbarReducer from './toolbar/toolbar.reducer';
import userReducer from './user/user.reducer';
import rolesReducer from './roles/roles.reducer';
import vehicleTypeReducer from './vehiclesTypes/vehicleTypes.reducer';
import weekScheduleReducer from './week-schedule/week-schedule.reducer';
import zoneReducer from './zone/zone.reducer';

export const rootReducer = combineReducers({
  authReducer,
  cityControlReducer,
  cityReducer,
  countryReducer,
  grappiReducer,
  liveOpsReducer,
  mapReducer,
  microzonesReducer,
  operationReducer,
  redbuttonReducer,
  saturationReducer,
  storeReducer,
  toolbarReducer,
  userReducer,
  rolesReducer,
  vehicleTypeReducer,
  weekScheduleReducer,
  zoneReducer
});

export type ApplicationState = ReturnType<typeof rootReducer>;
